module.exports = __webpack_public_path__ + "img/time-avg.58a99bf2.svg";